var e = {
  new: "New"
};
export { e as default };